import {Component, OnInit} from '@angular/core';
import {RealEstateAgentModel} from '../../shared/models/realEstateAgentModel';
import {RealEstateAgentService} from '../../shared/service/real-estate-agent.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  realEstateAgents: RealEstateAgentModel[] = [];

  constructor(private realEstateAgentService: RealEstateAgentService) {

    this.realEstateAgentService.getRealEstateAgentItems().subscribe((response: RealEstateAgentModel[]) => {
      this.realEstateAgents = response;
    });


  }

  ngOnInit() {
  }

  openMail(value: string) {
    window.location.href = 'mailto:' + value;
  }

  openPhone(value: string) {
    window.open('tel:' + value + '');
  }

  getBackgroundImageStyle(seller: RealEstateAgentModel) {
    return {
      'background-image': 'url(' + seller.imageUrl + ')',
    };
  }

}
